import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.629 4.832c.92-2.044 3.822-2.044 4.742 0l6.525 14.5C20.67 21.054 19.412 23 17.525 23H14v-2h3.525a.6.6 0 0 0 .547-.846L11.547 5.653a.6.6 0 0 0-1.095 0l-6.525 14.5a.6.6 0 0 0 .547.847H10v-7h2v11.126c1.725.444 3 2.01 3 3.874v8H7v-8a4.002 4.002 0 0 1 3-3.874V23H4.474c-1.887 0-3.145-1.947-2.37-3.667L8.628 4.832ZM8.999 29a2 2 0 1 1 4 0v6H9v-6Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M33.3 31.888a4.364 4.364 0 1 1-8.6 0l1.08-6.215c.086-.49-.09-.99-.466-1.319l-2.86-2.503a1.329 1.329 0 0 1-.454-1V19h2v1.546l2.631 2.303a3.427 3.427 0 0 1 1.12 3.167l-1.08 6.215a2.364 2.364 0 1 0 4.658 0l-1.08-6.215a3.428 3.428 0 0 1 1.119-3.167l2.631-2.303V19h2v1.851c0 .383-.165.747-.453 1l-2.861 2.503a1.428 1.428 0 0 0-.467 1.319l1.081 6.215ZM19.645 4H29v2h-6.647l3.385 11h6.466l2.538-11h-1.818l-1.078 5H29.8l1.51-7h5.947l-3.462 15h-9.534L19.645 4Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramBuildingRenovation40 = createIcon(IconComponent);